import { BlocksIconSocialInstagram } from 'blocks-nextjs/blocks-web-components/components/icon/icons/social-instagram';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSocialInstagram = createComponent({
  react: React,
  tagName: 'cat-icon-social-instagram',
  elementClass: BlocksIconSocialInstagram
});
